<div class="overlay" *ngIf="visible" (click)="close()"></div>
<div class="stock-fulfillment-panel" [class.open]="visible">
  <div class="panel-container">
    <div class="panel-header">
      <div class="header-content">
        <button class="icon-button" (click)="close()">
          <app-svg-icon svgIcon="close"></app-svg-icon>
        </button>
        <h2 class="panel-title">{{"quotations_and_orders.warehouse_stock.product_details" | translate}}</h2>
      </div>
    </div>
    <ng-container *ngIf="localProduct">
      <form [formGroup]="form" style="width: 100%;">
        <div class="panel-body">
          <div class="panel-content">
            <div class="product-info-section">
              <h3 class="section-title">
                <ui-copyable size="big" [value]="localProduct.name" [label]="'common.name' | translate">{{ localProduct.name }}</ui-copyable>
              </h3>
              <div class="info-row">
                <span class="info-label">{{"quotations_and_orders.warehouse_stock.brand" | translate}} :</span>
                <ui-copyable class="info-value" [value]="localProduct.brand?.name || localProduct.brand_name" [label]="'quotations_and_orders.warehouse_stock.brand' | translate">{{ localProduct.brand?.name || localProduct.brand_name || "N/A" }}</ui-copyable>
              </div>
              <div class="info-row">
                <span class="info-label">{{"quotations_and_orders.warehouse_stock.ean" | translate}} :</span>
                <ui-copyable class="info-value" [value]="localProduct.barcode" [label]="'quotations_and_orders.warehouse_stock.ean' | translate">{{ localProduct.barcode || "N/A" }}</ui-copyable>
              </div>
              <div class="info-row">
                <span class="info-label">{{"quotations_and_orders.warehouse_stock.sku" | translate}} :</span>
                <ui-copyable class="info-value" [value]="localProduct.sku" [label]="'quotations_and_orders.warehouse_stock.sku' | translate">{{ localProduct.sku || "N/A" }}</ui-copyable>
              </div>
              <h3 class="section-sub-title">{{"custom_fields.custom_fields" | translate}}</h3>
              <div class="info-row">
                <app-object-custom-fields-view
                  [objectCustomFields]="objectCustomFields"
                  [currentLanguage]="currentLanguage"
                >
                </app-object-custom-fields-view>
              </div>
              <div class="info-row">
                <a class="details-product-button" target="_blank" routerLink="/inventory/{{localProduct.product_template_id}}">
                  <span class="details-product-text">{{"quotations_and_orders.warehouse_stock.view_product" | translate}}</span>
                  <app-svg-icon svgIcon="arrow-outward"></app-svg-icon>
                </a>
              </div>
            </div>

            <ng-container *ngIf="!localProduct.is_buy_x_get_y_line">
              <div class="separator"></div>

              <div class="notes-section">
                <h3 class="section-title">{{ 'quotations_and_orders.line_notes.column' | translate }}</h3>
                
                <div
                  class="line-notes-container"
                  [class.clickable]="canEditOrder"
                  (click)="canEditOrder && openLineNotesDialog()"
                >
                  <div class="line-notes-box" *ngIf="localProduct.notes; else addNoteState">
                    <p class="line-notes-text">{{ localProduct.notes }}</p>
                  </div>
                  <ng-template #addNoteState>
                    <div class="line-notes-empty">{{ 'quotations_and_orders.line_notes.placeholder' | translate }}</div>
                  </ng-template>
                </div>
              </div>

              <!-- Available Pricebook Rules / gifts hidden front-end-wide due to business decision (WB-6694).
                   Not deleted — gated by loyaltyEnabled (forced false in FeatureFlagService). -->
              <div class="gifts-section" *ngIf="featureFlags.loyaltyEnabled">
                <h3 class="section-title">{{"quotations_and_orders.status_dialog.product_details.gifts" | translate}}</h3>
                <div class="info-row" *ngFor="let gift of getProductGifts()">
                  <span class="info-value">
                    <img src="assets/icones/reward.svg" alt="gift" srcset="" />
                    {{ gift.name }}
                  </span>
                </div>
              </div>

              <div class="separator"></div>

              <div class="sale-informations-section">
                <div class="section-header">
                  <h3 class="section-title">{{"quotations_and_orders.warehouse_stock.price" | translate}}</h3>
                  <div class="table-input">
                    <div class="input-frame align-self-end">
                      <mat-select name="default_currency" formControlName="order_currency" [disabled]="true">
                        <mat-select-trigger>
                          <span class="secondary--tag">{{ order.currency?.name + " (" + order.currency?.symbol + ")" }}</span>
                        </mat-select-trigger>
                        <mat-option [value]="order.currency" selected>{{ order.currency?.name + " (" + order.currency?.symbol + ")" }}</mat-option>
                      </mat-select>
                    </div>
                  </div>
                </div>

                <div class="info-row">
                  <span class="info-label">{{"quotations_and_orders.warehouse_stock.msrp" | translate}} :</span>
                  <div class="table-input full-width">
                    <div class="input-frame">
                      <span class="input-value">{{ localProduct.price_unit }} {{ order.currency?.symbol }}</span>
                    </div>
                  </div>
                </div>
                <div class="info-row">
                  <span class="info-label">{{"quotations_and_orders.warehouse_stock.discount_on_msrp" | translate}} :</span>
                  <div class="table-input full-width">
                    <div class="input-container with-symbol" [class.error]="form.get('discount')?.invalid && (form.get('discount')?.touched || form.get('discount')?.dirty)">
                      <input type="number" formControlName="discount" name="discount" min="0" max="100" [placeholder]="'0'" (input)="updateDiscount($event)" [readonly]="!canEdit"/>
                      <span class="input-symbol">%</span>
                    </div>
                    <div class="error" *ngIf="form.get('discount')?.invalid && (form.get('discount')?.touched || form.get('discount')?.dirty)">
                      <small *ngIf="form.get('discount')?.hasError('required')">
                        {{ "validation.required" | translate }}
                      </small>
                      <small *ngIf="form.get('discount')?.hasError('min') && (form.get('discount')?.touched || form.get('discount')?.dirty)">
                        {{ "validation.min" | translate : { min: form.get('discount')?.getError('min').min } }}
                      </small>
                      <small *ngIf="form.get('discount')?.hasError('max') && (form.get('discount')?.touched || form.get('discount')?.dirty)">
                        {{ "validation.max" | translate : { max: form.get('discount')?.getError('max').max } }}
                      </small>
                    </div>
                  </div>
                </div>

                <div class="info-row">
                  <span class="info-label">{{"quotations_and_orders.warehouse_stock.final_price" | translate}} :</span>
                  <div class="table-input full-width">
                    <div class="input-container with-symbol" [class.error]="form.get('final_price')?.invalid && (form.get('final_price')?.touched || form.get('final_price')?.dirty)">
                      <input type="number" formControlName="final_price" name="final_price" min="0" [placeholder]="'0'" (input)="updateFinalPrice($event)" [readonly]="!canEdit"/>
                      <span class="input-symbol">{{ order.currency?.symbol }}</span>
                    </div>
                    <div class="error" *ngIf="form.get('final_price')?.invalid && (form.get('final_price')?.touched || form.get('final_price')?.dirty)">
                      <small *ngIf="form.get('final_price')?.hasError('required')">
                        {{ "validation.required" | translate }}
                      </small>
                      <small *ngIf="form.get('final_price')?.hasError('min') && (form.get('final_price')?.touched || form.get('final_price')?.dirty)">
                        {{ "validation.min" | translate : { min: form.get('final_price')?.getError('min').min } }}
                      </small>
                      <small *ngIf="form.get('final_price')?.hasError('max') && (form.get('final_price')?.touched || form.get('final_price')?.dirty)">
                        {{ "validation.max" | translate : { max: form.get('final_price')?.getError('max').max } }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div class="separator"></div>

              <div class="warehouse-allocation-section">
                <h3 class="section-title">{{"quotations_and_orders.warehouse_stock.order_fulfillment" | translate}} :</h3>
                <div class="info-row" *ngIf="!isMultiWarehouseStock()">
                  <span class="info-label">{{"quotations_and_orders.warehouse_stock.stock" | translate}} :</span>
                  <span *ngIf="localProduct.is_owned else notOwned" class="info-value">{{ "quotations_and_orders.warehouse_stock.stock_quantity" | translate : { stock: stock } }}</span>
                  <ng-template #notOwned>
                    <span class="info-value">
                      <span class="tag-not-owned">
                        {{'inventory.notOwned' | translate}}
                      </span>
                    </span>
                  </ng-template>
                </div>
                <div class="fulfillment-table">
                  <div class="table-header">
                    <span class="header-cell"></span>
                    <span class="header-cell">Quantity</span>
                    <span class="header-cell">Handling Unit</span>
                    <span class="header-cell">Total units</span>
                  </div>

                  <div class="table-row">
                    <div class="table-cell">
                      <span class="table-cell-value label-text">
                        {{"quotations_and_orders.warehouse_stock.order_quantity" | translate}} :
                      </span>
                    </div>
                    
                    <div class="table-cell">
                      <div class="input-container" [class.error]="form.get('order_quantity')?.invalid && (form.get('order_quantity')?.touched || form.get('order_quantity')?.dirty)">
                        <input type="number" formControlName="order_quantity" name="order_quantity" min="0" [placeholder]="'0'" (input)="updateOrderQuantity($event)" [readonly]="!canEdit"/>
                      </div>
                      <div class="error" *ngIf="form.get('order_quantity')?.invalid && (form.get('order_quantity')?.touched || form.get('order_quantity')?.dirty)">
                        <small *ngIf="form.get('order_quantity')?.hasError('required')">
                          {{ "validation.required" | translate }}
                        </small>
                        <small *ngIf="form.get('order_quantity')?.hasError('min')">
                          {{ "validation.min" | translate : { min: 0 } }}
                        </small>
                        <small *ngIf="form.get('order_quantity')?.hasError('max')">
                          {{ "validation.max" | translate : { max: form.get('order_quantity')?.getError('max').max } }}
                        </small>
                      </div>
                    </div>

                    <div class="table-cell">
                      <div class="input-container">
                        <mat-select formControlName="handling_unit" class="custom-select" panelClass="custom-select-panel" [disabled]="!canEdit">
                            <mat-select-trigger>
                              <div class="trigger-content" style="padding: 10px;">
                                  <span class="hu-name-tag">{{ form.get('handling_unit')?.value?.name }}</span>
                                  <span class="hu-qty-text">(x{{ form.get('handling_unit')?.value?.quantity }})</span>
                              </div>
                            </mat-select-trigger>
                            <mat-option *ngFor="let hu of handlingUnits" [value]="hu">
                              <div class="option-content">
                                  <span class="hu-name-tag">{{ hu.name }}</span>
                                  <span class="hu-qty-text">(x{{ hu.quantity }})</span>
                              </div>
                            </mat-option>
                        </mat-select>
                      </div>
                    </div>

                    <div class="table-cell">
                      <span class="table-cell-value value-text">
                        {{ getTotalUnits() || localProduct.quantity }}
                      </span>
                    </div>
                  </div>
                </div>
                <ng-container *ngIf="hasErrorStock() && isMultiWarehouseStock()">
                  <div class="availability-message" *ngIf="outOfStock()">
                    {{ "quotations_and_orders.warehouse_stock.only_available_across_all_warehouses" | translate : { 
                      sumAvailableQuantity: sumAvailableQuantity(), 
                      localProductQuantity: localProduct.quantity,
                      remainingQuantity: localProduct.quantity - sumAvailableQuantity()
                    } }}
                  </div>
                  <div class="availability-message" *ngIf="!outOfStock() && outOfStockMainWarehouse()">
                    {{ "quotations_and_orders.warehouse_stock.only_available_in_default_warehouse" | translate : { 
                      mainWarehouseAvailableQuantity: primaryWarehouse()?.available_quantity || 0, 
                      localProductQuantity: localProduct.quantity
                    } }}
                  </div>
                </ng-container>
                <div class="info-row" *ngIf="isMultiWarehouseStock()">
                  <span class="info-label">{{"quotations_and_orders.warehouse_stock.allocation" | translate}}</span>
                </div>
                <div class="warehouse-table" *ngIf="isMultiWarehouseStock()">
                  <div class="table-header">
                    <span class="header-cell">{{"quotations_and_orders.warehouse_stock.warehouse" | translate}}</span>
                    <span class="header-cell">{{"quotations_and_orders.warehouse_stock.stock" | translate}}</span>
                    <span class="header-cell">{{"quotations_and_orders.warehouse_stock.order_allocation" | translate}}</span>
                  </div>

                  <div class="table-row" *ngFor="let warehouse of warehouses; let i = index">
                    <div class="table-cell">
                      <span class="table-cell-value">{{ warehouse.name }} <span class="status-badge" *ngIf="warehouse.is_primary"> {{"quotations_and_orders.warehouse_stock.primary" | translate}} </span></span>
                    </div>
                    <div class="table-cell">
                      <span class="table-cell-value">{{ warehouse.available_quantity > 0 ? warehouse.available_quantity : 0 }}</span>
                    </div>
                    <div class="table-cell">
                      <div class="input-container" [class.error]="form.get('order_allocation_' + warehouse.warehouse_id)?.invalid && (form.get('order_allocation_' + warehouse.warehouse_id)?.touched || form.get('order_allocation_' + warehouse.warehouse_id)?.dirty)">
                        <input type="number" name="order_allocation" min="0" [placeholder]="'0'" value="0" [formControlName]="'order_allocation_' + warehouse.warehouse_id" (input)="updateOrderAllocation()" [readonly]="!canEdit"/>
                      </div>
                      <div class="error" *ngIf="form.invalid && (form.touched || form.dirty)">
                        <small *ngIf="form.get('order_allocation_' + warehouse.warehouse_id)?.hasError('required')">
                          {{ "validation.required" | translate }}
                        </small>
                        <small *ngIf="form.get('order_allocation_' + warehouse.warehouse_id)?.hasError('min') && (form.get('order_allocation_' + warehouse.warehouse_id)?.touched || form.get('order_allocation_' + warehouse.warehouse_id)?.dirty)">
                          {{ "validation.min" | translate : { min: form.get('order_allocation_' + warehouse.warehouse_id)?.getError('min').min } }}
                        </small>
                        <small *ngIf="form.get('order_allocation_' + warehouse.warehouse_id)?.hasError('max') && (form.get('order_allocation_' + warehouse.warehouse_id)?.touched || form.get('order_allocation_' + warehouse.warehouse_id)?.dirty)">
                          {{ "validation.max" | translate : { max: form.get('order_allocation_' + warehouse.warehouse_id)?.getError('max').max } }}
                        </small>
                      </div>
                    </div>
                  </div>

                  <div class="separator"></div>

                  <div class="table-footer">
                    <div class="footer-cell">{{"quotations_and_orders.warehouse_stock.total" | translate}}</div>
                    <div class="footer-cell">
                      {{ getTotalAvailableQuantity() }}
                    </div>
                    <div class="footer-cell">
                      {{ allocatedQuantity }}
                      <span class="message-text" *ngIf="outOfStock()">{{"quotations_and_orders.warehouse_stock.out_of" | translate }} {{ getTotalAvailableQuantity() }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="panel-footer" *ngIf="canEdit && !localProduct.is_buy_x_get_y_line">
          <div class="error-message">
            <ng-container *ngIf="outOfStock()">
              <app-svg-icon svgIcon="warning"></app-svg-icon>
              <span class="message-text">{{"quotations_and_orders.warehouse_stock.current_stock_does_not_support_complete_fulfillment" | translate}}</span>
            </ng-container>
            <ng-container *ngIf="!outOfStock() && someWarehousesCantFulfill()">
              <app-svg-icon svgIcon="warning"></app-svg-icon>
              <span class="message-text">{{"quotations_and_orders.warehouse_stock.some_warehouses_cannot_fulfill_the_order" | translate}}</span>
            </ng-container>
          </div>
          <div class="success-message" *ngIf="!outOfStock() && !someWarehousesCantFulfill() && warehousesCanFulfill()">
            <app-svg-icon svgIcon="check-circle-new"></app-svg-icon>
            <span class="message-text">{{"quotations_and_orders.warehouse_stock.this_allocation_ensures_complete_product_fulfillment" | translate}}</span>
          </div>
          <button class="confirm-button" [class.delete-product]="form.get('order_quantity')?.value <= 0 || form.get('final_price')?.value <= 0" (click)="confirmAllocation()">
            <ng-container *ngIf="form.get('order_quantity')?.value > 0 && form.get('final_price')?.value > 0 else deleteProduct">
            <span class="button-text">
                {{ outOfStock() ? ("quotations_and_orders.warehouse_stock.adjust_order_quantity" | translate) : ("quotations_and_orders.warehouse_stock.confirm" | translate) }}
              </span>
              <app-svg-icon svgIcon="arrow-right"></app-svg-icon>
            </ng-container>
              <ng-template #deleteProduct>
                <app-svg-icon svgIcon="trash-cc"></app-svg-icon>
                <span class="button-text">
                  {{ "quotations_and_orders.warehouse_stock.delete_product" | translate }} </span>
              </ng-template>
            </button>
        </div>
      </form>
    </ng-container>
  </div>
</div>
